export const NO_WHOLE_REDEEM_MESSAGE = 'No whole credits available to withdraw. Remaining cents stay in the game; nothing was transferred.';
export const REDEEM_REVIEW_MESSAGE = 'Redeem outcome is being verified. Do not retry.';

export function gameRedeemFeedback(payload) {
  const result = payload?.transaction || payload || {};
  const statuses = [result.status, result.final_status].map(value => String(value || '').toLowerCase());
  if (result.pending || result.pending_reconciliation_id || statuses.some(value => [
    'pending', 'processing', 'queued', 'unknown', 'manual_review', 'pending_provider_clear',
  ].includes(value))) {
    return { type: 'info', message: REDEEM_REVIEW_MESSAGE, pending: true };
  }
  if (statuses.includes('no_whole_balance')) {
    return { type: 'info', message: NO_WHOLE_REDEEM_MESSAGE, pending: false };
  }
  if (result.success === false || statuses.some(value => ['failed', 'error', 'cancelled'].includes(value))) {
    return { type: 'error', message: result.message || 'Redeem did not complete. Contact support.', pending: false };
  }
  if (result.success === true && result.provider_redeemed_amount != null && result.provider_redeemed_amount !== '' && Number(result.provider_redeemed_amount) === 0) {
    return { type: 'info', message: NO_WHOLE_REDEEM_MESSAGE, pending: false };
  }
  if (result.success === true && Number(result.provider_redeemed_amount ?? result.provider_redeem_amount) > 0) {
    return { type: 'success', message: result.message || 'Game credits redeemed.', pending: false };
  }
  return { type: 'info', message: REDEEM_REVIEW_MESSAGE, pending: true };
}
